/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export default class Operations
{
  constructor (routes, notifications)
  {
    const createOperation = ({ routing, data }) =>
    {
      const { route, args, verb } = routes.match(routing);

      return { route, args, verb, data: route.upcastData(data) };
    };

    const compareOperations = (lhs, rhs) =>
    {
      return lhs.route.index - rhs.route.index;
    };

    this.operations = notifications.map(createOperation).sort(compareOperations);
  }


  upsert (application)
  {
    for (const operation of this.operations)
    {
      operation.route.upsert(application, operation);
    }
  }


  remove (application)
  {
    for (const operation of this.operations.slice().reverse())
    {
      operation.route.remove(application, operation);
    }
  }


};
